import { fetchWithAuth } from "../../utils/fetchWithAuth";
import { AUTH_SOURCE } from "../../constants/authSource";
import { useGlobalStore } from "../../context/UserContext/userContext";
import { socketConfig } from "../../utils/authConfig";
import { getReportingApiBaseUrl } from "../../config/apiBaseUrls";

export const getCatalog = async (catalogType) => {
  const { isWixAuth, authSource } = useGlobalStore.getState();
  const isCreAuth = authSource === AUTH_SOURCE.CRE;
  const baseUrl = getReportingApiBaseUrl();
  const url = new URL(`${baseUrl}/api/Catalog/GetCatalog`);
  const response = await fetchWithAuth(url, {
    method: "POST",
    body: JSON.stringify(catalogType),
  });

  let data;
  if (isWixAuth || isCreAuth) {
    const text = await response.text();
    try {
      data = JSON.parse(text);
    } catch (e) {
      console.warn("[GetCatalog] Wix: response is not JSON (catalogType:", catalogType?.catalogType, "). Status:", response.status, "Preview:", text.slice(0, 80));
      return null;
    }
  } else {
    data = await response.json();
  }

  if (!data.success) {
    throw new Error("Failed to fetch catalog");
  }
  return data.payload;
};

/**
 * Fetch anatomies from new endpoint
 * Uses socket config base URL
 * @returns {Promise<Array>} Array of all anatomy items (no type filtering)
 */
export const getAnatomies = async () => {
  // Use socket config base URL
  const baseUrl = socketConfig.url;
  const url = new URL(`${baseUrl}/api/admin/anatomies`);

  const response = await fetchWithAuth(url, {
    method: "GET",
  });

  const text = await response.text();
  let data;
  try {
    data = JSON.parse(text);
  } catch (e) {
    console.warn("[getAnatomies] Response is not JSON. Status:", response.status, "Preview:", text.slice(0, 80));
    return { catalogItems: [] };
  }

  if (!response.ok) {
    throw new Error("Failed to fetch anatomies");
  }

  // Return all items without type filtering
  const anatomies = data.anatomies || [];

  // Return in format compatible with existing code
  return {
    catalogItems: anatomies.map((item) => ({
      id: item.id,
      code: item.code,
      name: item.name,
      language: item.language,
      type: item.type,
      promptFile: item.promptFile,
    })),
  };
};
